import React from 'react';

const Loader = () => {
    return (
        <div className='centrar p-30' style={{height:'70vh'}} style={{backgroundColor:'#c1f0f8'}}>
            <div className='loaderlogo'>
                <div className="loader"> 
                    <img className='loaderimg' src= "/images/null.png" alt='logodento'/> 
                </div>
            </div>
        </div>
    );
};

export default Loader;